/**
 * Returns the price label in the format `42.00`.
 * @param  {number} price
 * @returns {string}
 */
export default function getPriceStringUtil (price) {
  return price.toFixed(2)
}
